import { gettext } from '@eventbrite/i18n';

export const SALES_END_ON = gettext('Sales end on %(date)s');
export const SALES_NOT_STARTED = gettext('Sales not started');
export const SALES_START_ON = gettext('Sales start on %(date)s');
export const SALES_ENDED = gettext('Sales ended');
export const UNAVAILABLE = gettext('Unavailable');
